import React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

interface P {
  timeout: number;
  children: React.ReactElement | null;
  active?: boolean;
}

/*
children CSS:

transition: opacity ${timeout}ms ease-in-out;
.enter {
  opacity: 0;
}
.enter-active {
  opacity: 1;
}
.exit {
  opacity: 1;
}
.exit-active {
  opacity: 0;
}

*/

const displayNoneStyle = {
  style: { display: "none" },
};

const FirstChild = (props: { children: React.ReactNode }) =>
  React.Children.toArray(props.children)[0] || null;

const Toggle = ({ children, timeout, active }: P) => {
  const [hidden, setHidden] = React.useState(!active);
  const handleHide = React.useCallback(() => setHidden(true), []);
  const handleShow = React.useCallback(() => setHidden(false), []);
  if (active !== undefined) {
    if (!children) return null;

    return (
      <CSSTransition onEnter={handleShow} onExited={handleHide} in={active} timeout={timeout}>
        {React.cloneElement(children, hidden && !active ? displayNoneStyle : undefined)}
      </CSSTransition>
    );
  }

  return (
    <TransitionGroup component={FirstChild}>
      {children ? <CSSTransition timeout={timeout}>{children}</CSSTransition> : undefined}
    </TransitionGroup>
  );
};

export default Toggle;
